import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession, getCurrentUser, signOut } from "../utils/authSession";
import Loader from "../components/Loader";
import host from "../global";
import { loadCompany } from "../utils/analytics";

function RoleRedirect() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function redirectBasedOnRole() {
      try {
        sessionStorage.removeItem("impersonationToken");
        localStorage.removeItem("impersonatedUser");

        const session = await fetchAuthSession();
        const { accessToken } = session.tokens ?? {};
        const groups = accessToken?.payload["cognito:groups"] ?? [];
        const { userId } = await getCurrentUser();

        if (accessToken) {
          sessionStorage.setItem("accessToken", accessToken.toString());
          await new Promise((resolve) => setTimeout(resolve, 0));
        }

        // The dashboard's first page view should already carry the company
        // and is_internal; waits at most a moment for them
        if (accessToken && (groups.includes("Company_Admin") || groups.includes("HR"))) {
          await loadCompany(host, accessToken.toString());
        }

        if (groups.includes("ConvAI_Admin")) {
          navigate(`/geniehireadmin/dashboard`);
        } else if (groups.includes("Company_Admin")) {
          navigate(`/org-admin/dashboard`);
        } else if (groups.includes("HR")) {
          navigate(`/hr/dashboard`);
        } else {
          // Must clear the stored copy before navigating back to "/" --
          // LoginPage resumes any session it finds there, and signOut() alone
          // doesn't touch this (it only revokes server-side), so without this
          // a valid-but-groupless token bounces forever between "/" and here.
          sessionStorage.removeItem("accessToken");
          await signOut();
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } catch (err) {
        navigate("/not-found");
      } finally {
        setLoading(false);
      }
    }
    redirectBasedOnRole();
  }, [navigate]);

  return loading ? <Loader /> : null;
}

export default RoleRedirect;
